
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.325 6.99a6.894 6.894 0 0 1 3.966 12.53 10.974 10.974 0 0 1 5.013 3.92 1 1 0 0 1-1.636 1.15 8.979 8.979 0 0 0-14.686 0 1 1 0 0 1-1.636-1.15 10.974 10.974 0 0 1 5.012-3.92 6.894 6.894 0 0 1 3.967-12.53Zm0 2a4.894 4.894 0 1 0 0 9.788 4.894 4.894 0 0 0 0-9.788Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.805 7.098a1 1 0 0 0 .542 1.925l-.27-.962-.272-.963Zm6.454 2.84-.76.65.76-.65Zm1.309 2.664-.979.205.979-.205Zm-.424 3.737.908.418-.908-.418Zm-5.442 2.484a1 1 0 0 0 0 2v-2Zm0 0a1 1 0 1 0 0 2v-2Zm7.48 5.884a1 1 0 0 0 1.636-1.15l-.818.575-.819.575ZM19.075 8.06l.271.962a4.993 4.993 0 0 1 5.152 1.564l.76-.65.76-.649a6.993 6.993 0 0 0-7.214-2.19l.271.963Zm6.183 1.877-.76.65c.555.65.922 1.415 1.09 2.22l.979-.206.979-.204a6.988 6.988 0 0 0-1.527-3.11l-.76.65Zm1.309 2.664-.979.205a4.99 4.99 0 0 1-.353 3.113l.908.419.908.418a6.99 6.99 0 0 0 .495-4.36l-.98.205Zm-.424 3.737-.908-.419a4.993 4.993 0 0 1-4.534 2.903v2a6.993 6.993 0 0 0 6.35-4.066l-.908-.418Zm-5.442 3.484v1a9.129 9.129 0 0 1 7.48 3.884l.818-.575.818-.574a11.13 11.13 0 0 0-9.117-4.735l.001 1Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\">\r\n<path d=\"M11.3252 6.99023C15.1324 6.99023 18.2187 10.0766 18.2188 13.8838C18.2188 16.2143 17.0613 18.2728 15.291 19.5205C17.2853 20.2936 19.0396 21.6428 20.3037 23.4404C20.6211 23.8921 20.5121 24.5154 20.0605 24.833C19.6089 25.1506 18.9857 25.0422 18.668 24.5908C16.987 22.2004 14.2465 20.7772 11.3242 20.7773C8.40222 20.7776 5.66309 22.2005 3.98242 24.5908C3.66479 25.0426 3.04067 25.1516 2.58887 24.834C2.1373 24.5163 2.02814 23.8921 2.3457 23.4404C3.6098 21.6425 5.36398 20.2926 7.3584 19.5195C5.58891 18.2717 4.43164 16.2136 4.43164 13.8838C4.43171 10.0767 7.51813 6.99043 11.3252 6.99023ZM11.3252 8.99023C8.6227 8.99043 6.43171 11.1813 6.43164 13.8838C6.43164 16.5864 8.62265 18.7772 11.3252 18.7773C14.0279 18.7773 16.2188 16.5865 16.2188 13.8838C16.2187 11.1811 14.0279 8.99023 11.3252 8.99023Z\" fill=\"black\"/>\r\n<path d=\"M18.805 7.09824C18.2734 7.24801 17.9639 7.80037 18.1136 8.33196C18.2634 8.86355 18.8158 9.17307 19.3474 9.02329L19.0762 8.06077L18.805 7.09824ZM25.2594 9.93776L24.4989 10.5871L25.2594 9.93776ZM26.5679 12.6025L25.5891 12.8071V12.8071L26.5679 12.6025ZM26.1443 16.3387L27.0524 16.7574V16.7574L26.1443 16.3387ZM20.7021 18.8228C20.1498 18.8229 19.7021 19.2707 19.7022 19.823C19.7023 20.3752 20.15 20.8229 20.7023 20.8228L20.7022 19.8228L20.7021 18.8228ZM20.7015 18.8231C20.1492 18.8235 19.7018 19.2715 19.7022 19.8238C19.7026 20.3761 20.1507 20.8235 20.7029 20.8231L20.7022 19.8231L20.7015 18.8231ZM28.1813 24.7068C28.4987 25.1588 29.1224 25.2679 29.5744 24.9506C30.0264 24.6333 30.1356 24.0096 29.8182 23.5576L28.9998 24.1322L28.1813 24.7068ZM19.0762 8.06077L19.3474 9.02329C21.2226 8.49495 23.2338 9.10549 24.4989 10.5871L25.2594 9.93776L26.0199 9.28841C24.2481 7.21336 21.4313 6.35828 18.805 7.09824L19.0762 8.06077ZM25.2594 9.93776L24.4989 10.5871C25.0541 11.2374 25.4209 12.0028 25.5891 12.8071L26.5679 12.6025L27.5468 12.3978C27.3113 11.2716 26.7972 10.1988 26.0199 9.28841L25.2594 9.93776ZM26.5679 12.6025L25.5891 12.8071C25.8042 13.8361 25.6939 14.9272 25.2362 15.9201L26.1443 16.3387L27.0524 16.7574C27.6936 15.3667 27.8478 13.8379 27.5468 12.3978L26.5679 12.6025ZM26.1443 16.3387L25.2362 15.9201C24.4205 17.6893 22.6503 18.8226 20.7021 18.8228L20.7022 19.8228L20.7023 20.8228C23.4309 20.8225 25.9101 19.2353 27.0524 16.7574L26.1443 16.3387ZM20.7022 19.8231L20.7029 20.8231C23.6798 20.8209 26.4708 22.2703 28.1813 24.7068L28.9998 24.1322L29.8182 23.5576C27.733 20.5874 24.3306 18.8205 20.7015 18.8231L20.7022 19.8231Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/users.e99885079d18575a6dd34513a835c261.svg"),
        {
          React: SvgUsers,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      